export function Refunds({ supportEmail }: { supportEmail?: string }) {
  return (
    <article className="prose">
      <h1>Refund Policy</h1>
      <p className="updated">
        This is a starter policy for ReleaseMachine and is not a substitute for legal
        review.
      </p>

      <h2>If generation fails</h2>
      <p>
        ReleaseMachine is built to automatically detect a failed generation. If your
        campaign fails to generate and we're unable to complete it, you're entitled to a
        full refund — contact support with your order link and we'll process it.
      </p>

      <h2>If your campaign is delivered successfully</h2>
      <p>
        Because ReleaseMachine delivers a complete, automatically generated digital
        product immediately after payment, we generally don't offer refunds once a
        campaign has been successfully generated and made available to you. If you believe
        the output is significantly incomplete or doesn't match what was described on this
        site, contact us — we review these requests individually and will make it right
        where reasonable.
      </p>

      <h2>Accidental or duplicate charges</h2>
      <p>
        If you were charged more than once for the same order due to a technical issue,
        contact support and we'll refund the duplicate charge. Our payment processing is
        built to prevent this from happening automatically, but if it does, we'll fix it.
      </p>

      <h2>How to request a refund</h2>
      <p>
        Email{" "}
        {supportEmail ? <a href={`mailto:${supportEmail}`}>{supportEmail}</a> : "support"}{" "}
        with your order link (from the confirmation email or the URL of your order status
        page) and a brief description of the issue.
      </p>
    </article>
  );
}
